<template>
  <section>
    <div class="mod-block">
      <h3 class="title">子商品档案</h3>
      <el-button type="success" @click="addSubProduct">添加子商品</el-button>
      <mc-import
        ref="importGoods"
        :action="baseURL+'/commodityarchives/excelAnalysis/analysisItemSub'"
        title="商品批量导入"
        download-url="http://scmapi.bbg.com.cn/contentmanagement/file/down?id=1654150539672"
        @success="uploadSuccess">
        <el-button size="small" type="primary" plain>子商品导入</el-button>
        <!-- <div slot="tips">注意：条数不超过5000条</div> -->
        <!-- <div slot="result" slot-scope="slotProps">{{slotProps.data}}</div> -->
      </mc-import>
      <el-form :model="form" ref="form">
        <el-form-item prop="list" required :rules="[{validator: $validate.required}]">
          <el-table :data="form.list" style="max-width: 1000px;" max-height="260" v-loading="loading" size="mini">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="childItem" label="子商品编码"></el-table-column>
            <el-table-column prop="childItemDesc" label="子商品名称" min-width="180"></el-table-column>
            <el-table-column prop="flavorItem" label="口味商品-销售商品" width="160"></el-table-column>
            <el-table-column prop="barcode" label="商品条码"></el-table-column>
            <el-table-column prop="barcodeType" label="编码类型">
              <template slot-scope="scope">{{$selectMap.getName('barcode', scope.row.barcodeType)}}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-link type="primary" @click="edit(scope.row, scope.$index)">编辑</el-link>
                <el-link type="danger" @click="del(scope.$index)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <!-- <div class="global-pagination">
        <el-pagination background layout="sizes, prev, pager, next" :page-size="pager.pageSize" :current-page.sync="pager.pageNum" :total="pager.totalRow" @current-change="currentChange"></el-pagination>
      </div> -->
    </div>
    <!-- 新增 -->
    <SubCommodityAdd ref="addItem" @sure="handleAdd" :dataList="form.list"></SubCommodityAdd>
  </section>
</template>
<script>
  import SubCommodityAdd from './sub-commodity-add.vue'
  export default {
    inject: ['getComData'],
    components: {SubCommodityAdd},
    data () {
      return {
        loading: false,
        pager: {
          pageSize: 10,
          pageNum: 1,
          totalRow: 0
        },
        form: {
          list: []
        },
        baseURL: window.IPConfig.HOST ? (window.IPConfig.IP + ':' + window.IPConfig.HOST) : window.IPConfig.IP
        // tableData: []
      }
    },
    methods: {
      addSubProduct () {
        this.$refs.addItem.visible = true
      },
      edit (item, index) {
        this.$refs.addItem.editROw(item, index)
      },
      del (index) {
        this.$confirm('确认删除选中商品?').then(rs => {
          this.form.list.splice(index, 1)
        }).catch(rs => {})
      },
      currentChange (val) {
        this.pager.pageNum = val
        this.search()
      },
      search (pageNum) {
        this.loading = true
        if (pageNum !== undefined) {
          this.pager.pageNum = pageNum
        }
        let params = Object.assign(this.searchOpt || {}, {...this.pager})
        this.$ajax.get('/table', params).then(rs => {
          if (rs && rs.result && rs.result.list) {
            this.form.list = [...rs.result.list]
            this.pager.pageNum = rs.result.pageInfo.pageNum
            this.pager.totalRow = rs.result.pageInfo.totalRow
          }
        }).finally(() => {
          this.loading = false
        })
      },
      handleAdd (data) {
        let {index, ...obj} = data
        // 修改
        if (typeof index === 'number') {
          this.form.list.splice(index, 1, obj)
        } else { // 新增
          this.form.list.push(obj)
        }
      },
      uploadSuccess (data) {
        this.form.list = data
        this.$refs.importGoods.close()
      }
    },
    mounted () {
      let itemChildList = this.getComData().editData.itemChildList
      if (itemChildList && itemChildList.length > 0) {
        this.form.list = Object.assign([], itemChildList)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 25px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    /deep/ .el-table th.el-table__cell {
      background-color: #D2E8F2;
      color: #333;
    }
  }
  .el-table {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/taste/sub-commodity-archives.vue